"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tr = void 0;
var tr = {
  colors: {
    primary: {
      backgroundColor: function backgroundColor(get) {
        return get('colorScheme', 'primaryLighter');
      },
      backgroundColorHoverFocus: function backgroundColorHoverFocus(get) {
        return get('colorScheme', 'primary');
      },
      activeBackgroundColor: function activeBackgroundColor(get) {
        return get('colorScheme', 'dark10Alpha');
      },
      activeBackgroundColorHoverFocus: function activeBackgroundColorHoverFocus(get) {
        return get('colorScheme', 'dark10Alpha');
      }
    },
    secondary: {
      backgroundColor: function backgroundColor(get) {
        return get('colorScheme', 'secondaryLighter');
      },
      backgroundColorHoverFocus: function backgroundColorHoverFocus(get) {
        return get('colorScheme', 'secondary');
      },
      activeBackgroundColor: function activeBackgroundColor(get) {
        return get('colorScheme', 'dark10Alpha');
      },
      activeBackgroundColorHoverFocus: function activeBackgroundColorHoverFocus(get) {
        return get('colorScheme', 'dark10Alpha');
      }
    },
    success: {
      backgroundColor: function backgroundColor(get) {
        return get('colorScheme', 'successLighter');
      },
      backgroundColorHoverFocus: function backgroundColorHoverFocus(get) {
        return get('colorScheme', 'success');
      },
      activeBackgroundColor: function activeBackgroundColor(get) {
        return get('colorScheme', 'dark10Alpha');
      },
      activeBackgroundColorHoverFocus: function activeBackgroundColorHoverFocus(get) {
        return get('colorScheme', 'dark10Alpha');
      }
    },
    info: {
      backgroundColor: function backgroundColor(get) {
        return get('colorScheme', 'infoLighter');
      },
      backgroundColorHoverFocus: function backgroundColorHoverFocus(get) {
        return get('colorScheme', 'info');
      },
      activeBackgroundColor: function activeBackgroundColor(get) {
        return get('colorScheme', 'dark10Alpha');
      },
      activeBackgroundColorHoverFocus: function activeBackgroundColorHoverFocus(get) {
        return get('colorScheme', 'dark10Alpha');
      }
    },
    warning: {
      backgroundColor: function backgroundColor(get) {
        return get('colorScheme', 'warningLighter');
      },
      backgroundColorHoverFocus: function backgroundColorHoverFocus(get) {
        return get('colorScheme', 'warning');
      },
      activeBackgroundColor: function activeBackgroundColor(get) {
        return get('colorScheme', 'dark10Alpha');
      },
      activeBackgroundColorHoverFocus: function activeBackgroundColorHoverFocus(get) {
        return get('colorScheme', 'dark10Alpha');
      }
    },
    danger: {
      backgroundColor: function backgroundColor(get) {
        return get('colorScheme', 'dangerLighter');
      },
      backgroundColorHoverFocus: function backgroundColorHoverFocus(get) {
        return get('colorScheme', 'danger');
      },
      activeBackgroundColor: function activeBackgroundColor(get) {
        return get('colorScheme', 'dark10Alpha');
      },
      activeBackgroundColorHoverFocus: function activeBackgroundColorHoverFocus(get) {
        return get('colorScheme', 'dark10Alpha');
      }
    },
    light: {
      backgroundColor: function backgroundColor(get) {
        return get('colorScheme', 'lightLighter');
      },
      backgroundColorHoverFocus: function backgroundColorHoverFocus(get) {
        return get('colorScheme', 'lightDark');
      },
      activeBackgroundColor: function activeBackgroundColor(get) {
        return get('colorScheme', 'dark10Alpha');
      },
      activeBackgroundColorHoverFocus: function activeBackgroundColorHoverFocus(get) {
        return get('colorScheme', 'dark10Alpha');
      }
    },
    dark: {
      backgroundColor: function backgroundColor(get) {
        return get('colorScheme', 'darkLighter');
      },
      backgroundColorHoverFocus: function backgroundColorHoverFocus(get) {
        return get('colorScheme', 'dark');
      },
      activeBackgroundColor: function activeBackgroundColor(get) {
        return get('colorScheme', 'dark10Alpha');
      },
      activeBackgroundColorHoverFocus: function activeBackgroundColorHoverFocus(get) {
        return get('colorScheme', 'dark10Alpha');
      }
    },
    default: function _default(get) {
      return get('tr', 'colors', 'secondary');
    }
  }
};
exports.tr = tr;


//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-config/lib/theme/tr.js
// module id = 1190
// module chunks = 0